export const FETCH_ORDER_DETAIL_REQUESTED = 'FETCH_ORDER_DETAIL_REQUESTED';
export const FETCH_ORDER_DETAIL_SUCCEEDED = 'FETCH_ORDER_DETAIL_SUCCEEDED';
export const GET_ORDER_USER_PROFILE = 'GET_ORDER_USER_PROFILE';
export const MAP_LOCATION_TO_ORDER_ITEM = 'MAP_LOCATION_TO_ORDER_ITEM';
export const GET_ORDER_LOGS = 'GET_ORDER_LOGS';

